import { useEffect, useRef } from "react";
import getClient from "@/apis/client";
import {
  clearGuestDiagnostic,
  loadGuestDiagnostic,
} from "@/lib/guestDiagnosticStorage";

export function useSyncGuestDiagnostic() {
  const hasAttemptedRef = useRef(false);

  useEffect(() => {
    if (hasAttemptedRef.current) return;
    hasAttemptedRef.current = true;

    const payload = loadGuestDiagnostic();
    if (!payload) return;

    const client = getClient();
    client
      .post("/users/diagnostic_results", {
        kind: payload.kind,
        answers: payload.answers,
        resultType: payload.resultType,
        completedAt: payload.completedAt,
      })
      .then(() => {
        clearGuestDiagnostic();
      })
      .catch((err) => {
        // 既存あり(status:'already_exists' 200) はthenに来るので、ここは本物のエラーだけ
        // ユーザー影響はないので表示せず、localStorageは次回再試行のため残す
        if (err?.response?.status === 422) {
          // データ不正は再送しても無駄なので削除
          clearGuestDiagnostic();
        }
      });
  }, []);
}
